import { MRT_ColumnFiltersState } from "material-react-table";
import { OneViewFilter } from "../toLocalStorage";

type MRTComparisonOptions = {
    columnFilters: MRT_ColumnFiltersState;
    allViews: OneViewFilter[];
};
export const getMatchingView = (options: MRTComparisonOptions): OneViewFilter | undefined => {
    const { columnFilters, allViews } = options;

    const foundMatchingFilter = allViews.find((viewFilter) => {
        const numberOfCurrentFilters = columnFilters.length;
        const numberOfFiltersToApply = viewFilter.columnFilters.length;
        if (numberOfCurrentFilters !== numberOfFiltersToApply) {
            // Match cannot occur as numbers of filter to check is different;
            return false;
        }

        const areAllMatching = columnFilters.every((colFilter) => {
            const similarFilterInView = viewFilter.columnFilters.find((item) => item.id === colFilter.id);
            if (similarFilterInView === undefined) return false;

            const areValuesEqual = similarFilterInView.value === colFilter.value;
            if (areValuesEqual) return true;

            return false;
        });

        if (areAllMatching) {
            return true;
        }

        return false;
    });

    return foundMatchingFilter;
};
